import { gql } from "@apollo/client";

export const AssessmentSuggestionCitationFragment = gql`
  fragment AssessmentSuggestionCitation on AnswerCitationNode {
    sourceId
    sourceType
    title
    url
    date
    sourceProvider
  }
`;

export const AssessmentSuggestionFragments = gql`
  ${AssessmentSuggestionCitationFragment}
  fragment AssessmentSuggestion on SuggestionItemNode {
    title
    text
    citations {
      edges {
        node {
          ...AssessmentSuggestionCitation
        }
      }
    }
  }
  fragment AssessmentSuggestedAnswer on SuggestedQuestionNode {
    questionId
    questionText
    suggestions {
      edges {
        node {
          ...AssessmentSuggestion
        }
      }
    }
  }
`;

export default gql`
  ${AssessmentSuggestionFragments}
  query getAssessmentSuggestedAnswers($assessmentId: Int!) {
    assessment(assessmentId: $assessmentId) {
      id
      suggestedAnswers {
        edges {
          node {
            ...AssessmentSuggestedAnswer
          }
        }
      }
    }
  }
`;
